/**
*
* OwnLanguagePrompt
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import useCurrentUser from 'containers/User/useCurrentUser.js';
import Icon2 from 'components/media/Icon2/index.js';
import cx from 'utils/cx.js';

function OwnLanguagePrompt(props) {
  const { className } = props;
  const user = useCurrentUser();
  const writeOwnLanguagePrompt = user.profile.translationLanguage?.writeOwnLanguagePrompt;
  return writeOwnLanguagePrompt ? (
    <div className={cx('d-flex align-items-center', className)}>
      <Icon2 className="ss-language me-2 fs-4" />
      <div className="small">{writeOwnLanguagePrompt}</div>
    </div>
  ) : null;
}

OwnLanguagePrompt.propTypes = {
  className: PropTypes.string,
};
export default OwnLanguagePrompt;
